import React, { useEffect, useState } from 'react'

import { Col, Row, Span } from 'components'
import { ExpandIcon } from 'components/Icons'
import useToggle from 'hooks/useToggle'
import { COLORS, FONTS, FORMAT, SPACING } from 'utils'

import {
  CardContentStyled,
  CardStyled,
  CollapseInfo,
  CollapseStyled
} from './CollapseColumn.styles'

interface ICollapseColumn {
  nuContrato?: string
  nmFornecedor?: string
  nmSubContratada?: string
  nmDiretoriaExecutiva?: string
  nmDiretoria?: string
  nmGerenciaGeral?: string
  nmGerencia?: string
  inicio?: string
  fim?: string
  cre?: string
  dtVerificacao?: string
  entradaDia?: string
  retornoDia?: string
  efetivo?: string
  matricula?: string
  diasBloqueio?: string
  analista?: string
  isOpen?: boolean
  fixedOpen?: boolean
  toggleExpand?: (_id: any) => void
  index: number
  onlyFornecedor?: boolean
}
const CollapseColumn: React.FC<ICollapseColumn> = ({
  nuContrato,
  nmFornecedor,
  nmSubContratada,
  nmDiretoriaExecutiva,
  nmDiretoria,
  nmGerencia,
  nmGerenciaGeral,
  children,
  inicio,
  fim,
  cre,
  dtVerificacao,
  entradaDia,
  retornoDia,
  efetivo,
  matricula,
  diasBloqueio,
  analista,
  isOpen = false,
  toggleExpand,
  index,
  fixedOpen,
  onlyFornecedor = false
}) => {
  return (
    <CardStyled elevation={3}>
      <CardContentStyled isHeader>
        <CollapseInfo>
          {nuContrato ? (
            <Row alignItems="center" justifyContent="space-between">
              <Row alignItems="center">
                <Span
                  text="Contrato:"
                  fontSize="19px"
                  color={COLORS.black}
                  fontWeight={FONTS.bold}
                  marginRight={SPACING.spacing5}
                />
                <Span
                  text={nuContrato}
                  fontSize="19px"
                  color={COLORS.blueFonts}
                />
              </Row>

              <ExpandIcon
                isExpanded={!isOpen}
                onClick={() => toggleExpand(index)}
              />
            </Row>
          ) : (
            <Row alignItems="center" justifyContent="end">
              <ExpandIcon
                isExpanded={!isOpen}
                onClick={() => toggleExpand(index)}
              />
            </Row>
          )}

          <Col
            alignItems="start"
            justifyContent="center"
            marginBottom={SPACING.spacing10}
            marginTop={SPACING.spacing10}
          >
            <Row alignItems="center">
              <Span
                text="Fornecedor:"
                fontSize="18px"
                color={COLORS.black}
                fontWeight={FONTS.bold}
                marginRight={SPACING.spacing5}
              />
              <Span
                text={nmFornecedor}
                fontSize="13px"
                color={COLORS.black}
                marginTop="3px"
              />
            </Row>
            {nmSubContratada && nmSubContratada != '' && (
              <Row alignItems="center" marginTop={SPACING.spacing10}>
                <Span
                  text="SubContratada:"
                  fontSize="18px"
                  color={COLORS.black}
                  fontWeight={FONTS.bold}
                  marginRight={SPACING.spacing5}
                />
                <Span
                  text={nmSubContratada}
                  fontSize="13px"
                  color={COLORS.black}
                  marginTop="3px"
                />
              </Row>
            )}
            {cre && !onlyFornecedor && (
              <Row
                alignItems="center"
                marginBottom={SPACING.spacing10}
                marginTop={SPACING.spacing10}
              >
                <Row alignItems="center">
                  <Span
                    text="Início:"
                    fontSize="13px"
                    color={COLORS.black}
                    fontWeight={FONTS.bold}
                    marginRight={SPACING.spacing5}
                  />
                  <Span text={inicio} fontSize="13px" color={COLORS.black} />
                </Row>
                <Row alignItems="center" marginLeft={SPACING.spacing20}>
                  <Span
                    text="Fim:"
                    fontSize="13px"
                    color={COLORS.black}
                    fontWeight={FONTS.bold}
                    marginRight={SPACING.spacing5}
                  />
                  <Span text={fim} fontSize="13px" color={COLORS.black} />
                </Row>
              </Row>
            )}
            {!onlyFornecedor && (
              <Row
                alignItems="center"
                marginBottom={SPACING.spacing10}
                marginTop={SPACING.spacing10}
              >
                <Row alignItems="center">
                  <Span
                    text="DE:"
                    fontSize="13px"
                    color={COLORS.black}
                    fontWeight={FONTS.bold}
                    marginRight={SPACING.spacing5}
                  />
                  <Span
                    text={nmDiretoriaExecutiva}
                    fontSize="13px"
                    color={COLORS.black}
                  />
                </Row>
                <Row alignItems="center" marginLeft={SPACING.spacing20}>
                  <Span
                    text="DIR:"
                    fontSize="13px"
                    color={COLORS.black}
                    fontWeight={FONTS.bold}
                    marginRight={SPACING.spacing5}
                  />
                  <Span
                    text={nmDiretoria}
                    fontSize="13px"
                    color={COLORS.black}
                  />
                </Row>
              </Row>
            )}
            {!cre && !onlyFornecedor && (
              <Row
                alignItems="center"
                marginBottom={SPACING.spacing10}
                marginTop={SPACING.spacing10}
              >
                <Row alignItems="center">
                  <Span
                    text="GG:"
                    fontSize="13px"
                    color={COLORS.black}
                    fontWeight={FONTS.bold}
                    marginRight={SPACING.spacing5}
                  />
                  <Span
                    text={nmGerenciaGeral}
                    fontSize="13px"
                    color={COLORS.black}
                  />
                </Row>
                <Row alignItems="center" marginLeft={SPACING.spacing20}>
                  <Span
                    text="GER:"
                    fontSize="13px"
                    color={COLORS.black}
                    fontWeight={FONTS.bold}
                    marginRight={SPACING.spacing5}
                  />
                  <Span
                    text={nmGerencia}
                    fontSize="13px"
                    color={COLORS.black}
                  />
                </Row>
              </Row>
            )}
            {cre && !onlyFornecedor && (
              <>
                <Row
                  alignItems="center"
                  marginBottom={SPACING.spacing10}
                  marginTop={SPACING.spacing10}
                >
                  <Row alignItems="center">
                    <Span
                      text="CRE :"
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span
                      text={cre || null}
                      fontSize="13px"
                      color={COLORS.black}
                    />
                  </Row>
                  {dtVerificacao?.length > 0 && (
                    <Row alignItems="center" marginLeft={SPACING.spacing20}>
                      <Span
                        text="Data verificação: "
                        fontSize="13px"
                        color={COLORS.black}
                        fontWeight={FONTS.bold}
                        marginRight={SPACING.spacing5}
                      />
                      <Span
                        text={FORMAT.formatMMYYYY(dtVerificacao) || null}
                        fontSize="13px"
                        color={COLORS.black}
                      />
                    </Row>
                  )}
                  <Row alignItems="center" marginLeft={SPACING.spacing20}>
                    <Span
                      text="Entrada Dia: "
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span
                      text={entradaDia || null}
                      fontSize="13px"
                      color={COLORS.black}
                    />
                  </Row>
                  <Row alignItems="center" marginLeft={SPACING.spacing20}>
                    <Span
                      text="Retorno Dia: "
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span
                      text={retornoDia || null}
                      fontSize="13px"
                      color={COLORS.black}
                    />
                  </Row>
                </Row>

                <Row
                  alignItems="center"
                  marginBottom={SPACING.spacing10}
                  marginTop={SPACING.spacing10}
                >
                  <Row alignItems="center">
                    <Span
                      text="Analista :"
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span
                      text={analista || null}
                      fontSize="13px"
                      color={COLORS.black}
                    />
                  </Row>
                  <Row alignItems="center" marginLeft={SPACING.spacing20}>
                    <Span
                      text="Matrícula: "
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span
                      text={matricula || null}
                      fontSize="13px"
                      color={COLORS.black}
                    />
                  </Row>
                </Row>
              </>
            )}
            <Row
              alignItems="center"
              marginBottom={SPACING.spacing10}
              marginTop={SPACING.spacing10}
            >
              <Row alignItems="center">
                <Span
                  text="Qtd. Dias Bloqueio:  "
                  fontSize="13px"
                  color={COLORS.black}
                  fontWeight={FONTS.bold}
                  marginRight={SPACING.spacing5}
                />

                <Span
                  text={diasBloqueio || null}
                  fontSize="13px"
                  color={COLORS.black}
                />
              </Row>
              <Row alignItems="center" marginLeft={SPACING.spacing20}>

                <Span
                  text="Efetivo:  "
                  fontSize="13px"
                  color={COLORS.black}
                  fontWeight={FONTS.bold}
                  marginRight={SPACING.spacing5}
                />
                <Span
                  text={efetivo || null}
                  fontSize="13px"
                  color={COLORS.black}
                />
              </Row>
            </Row>
          </Col>
        </CollapseInfo>
      </CardContentStyled>
      <CollapseStyled
        in={fixedOpen ? fixedOpen : isOpen}
        timeout="auto"
        unmountOnExit
      >

        <CardContentStyled>{children}</CardContentStyled>
      </CollapseStyled>
    </CardStyled>
  )
}

export default CollapseColumn
